import { Box, Button, Dialog, Typography } from "@mui/material";
import { colors } from "../../../../../theme/palette";
import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction } from "react";

const WhyCreateGroupPopUp = ({
  isWhyCreateGroupPopUpOpen,
  setIsWhyCreateGroupPopUpOpen,
}: {
  isWhyCreateGroupPopUpOpen: boolean;
  setIsWhyCreateGroupPopUpOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t, i18n } = useTranslation();

  return (
    <Dialog
      open={isWhyCreateGroupPopUpOpen}
      onClose={() => setIsWhyCreateGroupPopUpOpen(false)}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "16px",
          background: "#FFF",
          border: "1px solid #EAECF0",
          maxWidth: "485px",
        },
      }}
    >
      <Typography
        variant="body14Bold"
        sx={{
          color: colors.Black,
          padding: "18px 0",
          textAlign: "center",
          width: "100%",
          borderBottom: "1px solid #EAECF0",
          marginBottom: "18px",
        }}
      >
        {t("pages.entity.groups.whyCreateGroupTitle")}
      </Typography>
      <Box
        component="ul"
        sx={{
          padding: "0 24px 30px",
          borderBottom: "1px solid #EAECF0",
        }}
      >
        <Typography
          variant="body14Bold"
          sx={{
            display: "block",
            color: colors.Black,
            padding: "18px 0",
            width: "100%",
            marginBottom: "14px",
          }}
        >
          {t("pages.entity.groups.makeDecisionEasy")}
        </Typography>
        <Typography
          component="li"
          variant="body16Regular"
          sx={{
            color: colors.Dark600,
            marginBottom: "24px",
            listStyle: "auto",
            listStylePosition: "inside",
            padding: "0 16px",
          }}
        >
          {t("pages.entity.groups.inviteMembersEffortlessly")}
        </Typography>
        <Typography
          component="li"
          variant="body16Regular"
          sx={{
            color: colors.Dark600,
            listStyle: "auto",
            listStylePosition: "inside",
            padding: "0 16px",
          }}
        >
          {t("pages.entity.groups.createVerifiedGroups")}
        </Typography>
      </Box>
      <Button
        variant="primary-sm"
        sx={{ margin: "0 24px 14px", width: "calc(100% - 48px)" }}
        onClick={() => setIsWhyCreateGroupPopUpOpen(false)}
      >
        {t("pages.entity.groups.gotIt")}
      </Button>
    </Dialog>
  );
};

export default WhyCreateGroupPopUp;
